import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["lines", "children", "html"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Typography } from '@mui/material';
import { DangerouslySetInnerHTML } from '../froala-dangerously-set-inner-html';
import { jsx as _jsx } from "react/jsx-runtime";
export var TypographyTruncate = function TypographyTruncate(_ref) {
  var lines = _ref.lines,
      children = _ref.children,
      _ref$html = _ref.html,
      html = _ref$html === void 0 ? false : _ref$html,
      typographyProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
    component: "span"
  }, typographyProps), {}, {
    sx: mergeSxProps(typographyProps.sx, {
      display: '-webkit-box',
      WebkitLineClamp: lines,
      WebkitBoxOrient: 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      '> p': {
        display: 'inline',
        margin: 0
      }
    }),
    "data-element": "Typography",
    "data-component": "TypographyTruncate",
    "data-source-file": "index.tsx",
    children: html && children ? /*#__PURE__*/_jsx(DangerouslySetInnerHTML, {
      body: children
    }) : children
  }));
};